import http from "../http-common";
/* eslint-disable */
class AbsensiService {
  absensiList(
    page,
    itemPerPage,
    keyword,
    noNpa,
    tahun,
    kategori,
    status,
    propinsiId,
    tanggal,
    bulan
  ) {
    return http.get(
      "/absensi/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&tahun=" +
        tahun +
        "&kategori=" +
        kategori +
        "&status=" +
        status +
        "&no_npa=" +
        noNpa +
        "&propinsi_id=" +
        propinsiId +
        "&tanggal=" +
        tanggal +
        "&bulan=" +
        bulan,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  downloadAbsensiReport(
    keyword,
    noNpa,
    tahun,
    kategori,
    status,
    propinsiId,
    tanggal,
    bulan
  ) {
    return http.get(
      "/report/absensi/pegawai/download?keyword=" +
        keyword +
        "&tahun=" +
        tahun +
        "&kategori=" +
        kategori +
        "&status=" +
        status +
        "&no_npa=" +
        noNpa +
        "&propinsi_id=" +
        propinsiId +
        "&tanggal=" +
        tanggal +
        "&bulan=" +
        bulan,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  getInvoice(id) {
    return http.get(`/invoice/${id}`, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new AbsensiService();
